import { now } from "@utils/date-utils";
import { Dayjs } from "dayjs";

export function isOldEnough(birthDate: Dayjs | string, minimalAge: number): boolean {
	const years = now().diff(birthDate, "years");

	return years >= minimalAge;
}
